import { render, staticRenderFns } from "./TableActions.vue?vue&type=template&id=4b1c6cb8&scoped=true&"
import script from "./TableActions.vue?vue&type=script&lang=js&"
export * from "./TableActions.vue?vue&type=script&lang=js&"
import style0 from "./TableActions.vue?vue&type=style&index=0&id=4b1c6cb8&prod&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b1c6cb8",
  null
  
)

export default component.exports